<template>
  <div>
    <CGU />

    <v-btn elevation="8" icon style="background: white; position: absolute; left: 10px; top: 10px; z-index: 99" @click="goBack()"><v-icon>mdi-chevron-left</v-icon></v-btn>

    <div class="mx-4 mt-15" style="margin: auto; text-align: center">
      <div class="text-h7" style="font-weight: 500">{{ $t('navigation.good_road_0') }}<br />{{ $t('navigation.good_road_1') }}</div>

      <v-img max-height="100" max-width="100" :src="current_site.logo" class="mt-6 mb-2 mx-auto"> </v-img>

      <div class="px-9 mt-9 text-subtitle-2">
        {{ $t('navigation.text_best_place_0') }}<br />
        <strong>{{ $t('navigation.text_best_place_1') }}</strong>
        <br />
        {{ $t('navigation.text_best_place_2') }}
      </div>

      <v-btn rounded disabled class="my-4 mt-9" block :color="config.COLORS.GRAY" style="color: black" elevation="2" x-large v-if="loadingGps && location !== undefined">
        <v-progress-circular :size="20" color="white" indeterminate left class="mr-4"></v-progress-circular>
        {{ loadingText }}
      </v-btn>
      <v-btn rounded class="my-4 mt-9" block :color="config.COLORS.ORANGE" style="color: white" elevation="2" x-large v-if="!loadingGps && location !== undefined" @click="drivingRoute()">
        {{ $t('navigation.open_gps') }}
      </v-btn>
    </div>
    <span class="px-2 px-2" style="cursor: pointer; background: white; position: absolute; right: 0px; bottom: 5px; z-index: 99; font-size: 0.6em" @click="openCGU()">
      {{ $t('cgu.openmodal') }}
    </span>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import { Config } from '@/config';
import CGU from '@/components/CGU';

export default {
  name: 'App',
  components: {
    CGU,
  },
  data() {
    return {
      config: Config,
      loadingGps: true,
      loadingText: this.$t('navigation.compute_driving'),
      notificationSent: false,
    };
  },
  computed: {
    ...mapState('sites', ['current_site', 'current_parking']),
    ...mapState('geoNotifPermissions', ['location', 'notificationPermission']),
    ...mapGetters('CGU', ['getCGUStatus']),
    drivingLink() {
      return `https://www.google.com/maps/dir/?api=1&origin=${this.location.lat},${this.location.lng}&destination=${this.current_parking.best_entrance_location.lat},${this.current_parking.best_entrance_location.lng}`;
    },
  },
  watch: {},
  async created() {},
  async mounted() {
    if (this.current_site === undefined || this.current_parking === undefined) {
      this.$router.push({ name: 'scene.sites.list' }).catch(() => {});
    } else {
      // Searching driving route ended
      setTimeout(() => {
        this.loadingGps = false;
      }, 1000);
    }
  },
  methods: {
    ...mapActions('CGU', {
      openCGUModal: 'open',
    }),
    goBack() {
      this.$router.go(-1);
    },

    isNotificationCanBeSent() {
      if (this.notificationPermission === true && 'serviceWorker' in navigator) {
        return true;
      }
      return false;
    },

    drivingRoute() {
      //Send notification if possible
      if (this.notificationPermission === true && 'serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
          if ('showNotification' in registration) {
            registration.showNotification(this.current_site.full_name, {
              vibrate: [200, 100, 200, 100, 200, 100, 200],
              tag: 'vibration-simple',
              icon: this.current_site.logo,
              body: this.$t('navigation.back_to_app'),
              data: {
                path: this.$router.resolve({
                  name: 'scene.find_parking_spot',
                }).href,
              },
            });
            this.notificationSent = true;
          }
        });
      }

      // Force open driving route after 500ms
      setTimeout(() => {
        window.open(this.drivingLink, '_blank');
      }, 500);
    },
    openCGU() {
      if (this.getCGUStatus === false) {
        this.openCGUModal();
      }
    },
  },
};
</script>

<style></style>
